import React from "react";
import "./Dimensions.css";

const identityFacts = [
  ["Diocese", "Archdiocese of Madras-Mylapore"],
  ["Patron", "St. John Bosco"],
  ["Established", "1966"],
  ["Canonically Erected", "2003"],
];

const historyItems = [
  {
    year: "1966",
    text: "Ayanavaram was separated from Perambur and erected as a parish on 4 December 1966. The first Parish Priest was Fr. Augustine Moolacherry.",
  },
  {
    year: "1978",
    text: "The parish was entrusted to the Salesians on 31 March 1978. The Church dedicated to St. John Bosco was built and blessed on 16 July 1978.",
  },
  {
    year: "2003",
    text: "The parish celebrated the Silver Jubilee of the new church. The Salesian Province directory also records the canonical erection of the Ayanavaram presence in 2003.",
  },
];

const parishMinistry = [
  "Holy Mass and Eucharistic celebrations",
  "Sacramental preparation",
  "Spiritual formation",
  "Prayer services",
  "Pious associations",
  "Parish celebrations",
  "Liturgical formation",
  "Family and community activities",
  "Pastoral accompaniment",
];

const dimensions = [
  {
    title: "Spiritual Identity",
    text: "The Shrine draws its spiritual identity from St. John Bosco, whose mission was centred on young people, especially those who were poor and vulnerable. The Salesian approach of reason, religion and loving kindness shapes parish life, youth ministry, education, social outreach and lay formation.",
  },
  {
    title: "Eucharistic Life",
    text: "The Eucharist is at the heart of parish life. The Shrine encourages Holy Mass, Confession and Reconciliation, Eucharistic Adoration, devotional prayer and participation throughout the liturgical year.",
  },
  {
    title: "Youth Ministry",
    text: "Young people are central to the Don Bosco mission. The youth ministry encourages faith formation, leadership, cultural activities, sports, service, volunteer opportunities, and personal and spiritual development.",
  },
  {
    title: "Educational Ministry",
    text: "The Shrine community is associated with Don Bosco Matriculation Higher Secondary School, Ayanavaram. Its educational approach emphasises academic excellence, character development, spiritual growth, moral formation and social responsibility.",
  },
  {
    title: "Social Outreach",
    text: "The Salesian mission reaches beyond the church building through activities such as the Evening Study Centre and social ministry, supporting children and families in the neighbourhood.",
  },
  {
    title: "Salesian Family",
    text: "Salesian Cooperators and ADMA participate in the mission through prayer, formation, apostolic service and support for young people and families.",
  },
  {
    title: "Liturgy And Participation",
    text: "The parish encourages choirs, altar service, readers, commentators, Eucharistic ministry, liturgical preparation, youth participation, parish associations, feast celebrations and community gatherings.",
  },
  {
    title: "Family Community",
    text: "Don Bosco Shrine seeks to help families grow through prayer, Eucharistic participation, sacramental life, faith formation, marriage and family accompaniment, children's spiritual development and service to those in need.",
  },
];

const values = [
  ["Faith", "Growing in friendship with Christ through prayer and the Sacraments."],
  ["Love", "Building a welcoming community where everyone is valued."],
  ["Youth", "Giving young people opportunities to grow, lead and serve."],
  ["Education", "Developing the whole person through knowledge, character and values."],
  ["Service", "Responding with compassion to people in need."],
  ["Community", "Working together as one parish family."],
  ["Salesian Spirit", "Living Don Bosco's approach of presence, accompaniment, joy and loving kindness."],
];

const communityToday = [
  "P. Thamathiruthuvam Irudayam - Rector / Parish Priest / Correspondent / Local Delegate for Salesian Cooperators",
  "P. Williams Paulraj - Vice-Rector / Principal / Assistant Parish Priest",
  "P. Jagadeesh Arulappan - Administrator / Assistant Parish Priest",
  "P. Adukanil Mathew - Confessor",
  "P. Amalraj Aaservatham - Parish Youth / Youth Services Coordinator / Assistant Parish Priest / Liturgical Animator",
  "P. Raymond Joseph (SLK) - Assistant Parish Priest",
];

const websiteSections = [
  "Parish Announcements",
  "Mass Timings",
  "Sacraments",
  "Parish Groups",
  "Youth Ministry",
  "Salesian Cooperators",
  "ADMA",
  "School",
  "Social Outreach",
  "Feast Celebrations",
  "Photo Gallery",
  "Video Gallery",
  "Parish News",
  "Prayer Requests",
  "Thanksgiving",
  "Contact Us",
  "Location / Google Maps",
  "Online Contributions",
  "Parish Documents",
];

const Dimensions = () => {
  return (
    <main className="dimensions-page">
      <section className="container dimensions-content">
        <article className="dimensions-intro">
          <div>
            <span className="dimensions-kicker">Dedicated To St. John Bosco</span>
            <h2>A Welcoming Spiritual Home</h2>
            <p>
              Don Bosco Shrine, Ayanavaram is a Catholic parish community in
              Chennai dedicated to St. John Bosco, the Founder and Father of the
              Salesian Congregation. Located in the heart of Ayanavaram, the
              Shrine seeks to be a place where people encounter Christ, grow in
              faith, accompany young people and families, and participate in a
              community of prayer and service.
            </p>
          </div>
          <div className="dimensions-address">
            <strong>Don Bosco Shrine</strong>
            <span>86, P.E. Koil West Mada Street</span>
            <span>Ayanavaram, Chennai - 600023</span>
            <span>Tamil Nadu, India</span>
          </div>
        </article>

        <div className="dimensions-facts">
          {identityFacts.map(([label, value]) => (
            <div key={label}>
              <span>{label}</span>
              <strong>{value}</strong>
            </div>
          ))}
        </div>

        <section className="dimensions-section">
          <div className="dimensions-section-heading">
            <span className="dimensions-kicker">Our History</span>
            <h2>Milestones Of The Parish</h2>
          </div>
          <div className="dimensions-timeline">
            {historyItems.map((item) => (
              <article key={item.year}>
                <strong>{item.year}</strong>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="dimensions-section dimensions-ministry">
          <div className="dimensions-section-heading">
            <span className="dimensions-kicker">Parish Ministry</span>
            <h2>Faith In Daily Life</h2>
            <p>
              The Shrine is first and foremost a faith community, bringing
              together families, children, young people, senior citizens and
              parish groups.
            </p>
          </div>
          <div className="dimensions-chip-list">
            {parishMinistry.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </section>

        <section className="dimensions-section">
          <div className="dimensions-section-heading">
            <span className="dimensions-kicker">Mission Dimensions</span>
            <h2>Faith, Education, Service And Community</h2>
          </div>
          <div className="dimensions-card-grid">
            {dimensions.map((item) => (
              <article key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="dimensions-vision-grid">
          <article>
            <span className="dimensions-kicker">Our Vision</span>
            <h2>A Home Where Faith Meets Life</h2>
            <p>
              To be a welcoming Catholic community inspired by St. John Bosco,
              where faith is celebrated, young people are empowered, families
              are strengthened, and every person is encouraged to live with
              dignity, hope and love.
            </p>
          </article>
          <article>
            <span className="dimensions-kicker">Our Mission</span>
            <h2>Prayer, Formation And Service</h2>
            <p>
              To proclaim Christ through prayer, Eucharistic life, education,
              youth accompaniment, family ministry, community participation and
              service to those in need, following the Salesian spirit of St.
              John Bosco.
            </p>
          </article>
        </section>

        <section className="dimensions-section">
          <div className="dimensions-section-heading">
            <span className="dimensions-kicker">Our Values</span>
            <h2>What Shapes The Shrine</h2>
          </div>
          <div className="dimensions-values">
            {values.map(([title, text]) => (
              <article key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="dimensions-two-column">
          <article>
            <span className="dimensions-kicker">Our Community Today</span>
            <h2>Current Salesian Community</h2>
            <ul>
              {communityToday.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
          <article>
            <span className="dimensions-kicker">Connect With The Shrine</span>
            <h2>Website Sections</h2>
            <div className="dimensions-mini-list">
              {websiteSections.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </article>
        </section>

        <section className="dimensions-closing">
          <p>Faith · Youth · Education · Family · Service</p>
          <blockquote>"Give me souls, take away the rest."</blockquote>
          <span>St. John Bosco</span>
        </section>
      </section>
    </main>
  );
};

export default Dimensions;
